export default {
    serverError: 'خطا در برقراری ارتباط با سرور',
};
